/**
 * @file   src\components\Inventory\EditInventory\InventoryPropertyTypes.js
 * @brief  This file is responsible for the view of inventory property type section.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useState, useEffect } from "react";
import { getPropertyTypes } from "../../../services/commonServices";
import { handleRadioButonChange } from "../../../actions/common";
import { usePrevious } from "../../../hooks/usePrevious";
import {
  ENTIRE_SPACE_INVENTY_TYPE,
  IS_ENTIRE_PLACE,
  IS_PRIVATE_ROOM,
  PRIVATE_ROOM_INVENTY_TYPE,
  INVENTORY_TYPE,
} from "../../../constants/common";
import { convertToNumber } from "../../../helpers/validations";

const InventoryPropertyTypes = (props) => {
  const {
    handleFormValues,
    propertyType,
    prptySubType,
    clearPreviousStates,
    propertyTypeError,
    subPropertyTypeError,
  } = props;

  // Initialize component state variables and constants.
  const [propertyList, setPropertyList] = useState([]);
  const [propertySubItems, setPropertySubItems] = useState([]);

  const previousValue = usePrevious(propertyType);
  const previousSubTypeValue = usePrevious(prptySubType);

  // To get the property sub types
  useEffect(() => {
    if (propertyType) {
      if (propertyType == IS_ENTIRE_PLACE) {
        getProperiesSubItems(ENTIRE_SPACE_INVENTY_TYPE);
      } else if (propertyType == IS_PRIVATE_ROOM) {
        getProperiesSubItems(PRIVATE_ROOM_INVENTY_TYPE);
      }
    }
    getProperties(INVENTORY_TYPE);
  }, []);

  // Api call for get the propery types
  const getProperties = async (adType) => {
    await getPropertyTypes(adType)
      .then((response) => {
        if (response.errorCode === 0 && _.get(response, "result", null)) {
          const propertyTypes = _.get(response, "result", null);
          setPropertyList(propertyTypes);
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  // To get the sub property items
  const getProperiesSubItems = async (adType) => {
    await getPropertyTypes(adType)
      .then((response) => {
        if (response.errorCode === 0 && _.get(response, "result", null)) {
          const propertyTypes = _.get(response, "result", null);
          setPropertySubItems(propertyTypes);
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  // on property type select
  const handlePropertyClick = (e, typeText) => {
    const value = handleRadioButonChange(e);
    if (value) {
      if (convertToNumber(value) == IS_ENTIRE_PLACE) {
        getProperiesSubItems(ENTIRE_SPACE_INVENTY_TYPE);
      } else if (convertToNumber(value) == IS_PRIVATE_ROOM) {
        getProperiesSubItems(PRIVATE_ROOM_INVENTY_TYPE);
      } else {
        setPropertySubItems([]);
      }
      clearPreviousSelectedValues(value);
      handleFormValues({
        prprtyType: value,
        prptyTypeTxt: typeText,
        prptySubType: "",
      });
    }
  };

  // to handle the sub property items selection
  const handlePropertySubItemClick = (e) => {
    const value = handleRadioButonChange(e);
    if (value) {
      clearPreviousSelectedValues(value);
      handleFormValues({ prptySubType: value });
    }
  };

  // To clear the previous selected values
  const clearPreviousSelectedValues = (currentSelectedValue) => {
    const isClearPrevious =
      convertToNumber(previousValue) !==
        convertToNumber(currentSelectedValue) ||
      convertToNumber(previousSubTypeValue) !==
        convertToNumber(currentSelectedValue);
    if (isClearPrevious) {
      clearPreviousStates();
    }
  };

  // to load the property type views
  const loadPropertyTypes = () => {
    const List =
      propertyList &&
      propertyList.map((pt) => {
        const typeId = _.get(pt, "PropertyTypeId", "");
        const typeText = _.get(pt, "PropertyTypeText", "");
        return (
          <>
            <label className="radio-wrap mb-3">
              <input
                type="radio"
                name="radio"
                value={typeId ? typeId : ""}
                checked={(propertyType && propertyType == typeId) || ""}
                onChange={(e) => handlePropertyClick(e, typeText)}
              />
              <span className={propertyTypeError && "red-marked-span"}>
                <div className="wantad-type-info">
                  <h2
                    className={
                      propertyTypeError ? "pb-0 red-marked-subheading" : "pb-0"
                    }
                  >
                    {_.get(pt, "PropertyTypeText", "")}
                  </h2>
                </div>
              </span>
            </label>
            {propertyType &&
            propertyType == typeId &&
            propertySubItems &&
            propertySubItems.length > 0 ? (
              <>
                <h6
                  className={
                    subPropertyTypeError
                      ? "sub-head mb-2 red-marked-subhead"
                      : "sub-head mb-2"
                  }
                >
                  Select type:*{" "}
                </h6>
                <div className="row">{loadPropertySubTypes()}</div>
              </>
            ) : (
              ""
            )}
          </>
        );
      });

    return List;
  };

  // sub property type view
  const loadPropertySubTypes = () => {
    const List =
      propertySubItems &&
      propertySubItems.map((pt) => {
        const typeId = _.get(pt, "PropertyTypeId", "");
        const Img = _.get(pt, "Img", "");
        return (
          <div className="col-md-6 pe-md-2">
            <label className="radio-wrap mb-3">
              <input
                type="radio"
                name="pst-radio"
                id={typeId}
                value={typeId ? typeId : ""}
                checked={(prptySubType && prptySubType == typeId) || ""}
                onChange={(e) => handlePropertySubItemClick(e)}
              />
              <span className={subPropertyTypeError && "red-marked-span"}>
                <div className="wantad-type-info">
                  <h2
                    className={
                      subPropertyTypeError
                        ? "pb-0 red-marked-subheading"
                        : "pb-0"
                    }
                  >
                    {_.get(pt, "PropertyTypeText", "")}
                  </h2>
                </div>
              </span>
            </label>
          </div>
        );
      });

    return List;
  };

  return <>{loadPropertyTypes()}</>;
};
export default InventoryPropertyTypes;
